export default __webpack_public_path__ + "static/media/cochin1.982a8818.jpg";